import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Signin from "./auth/signin/Signin";
import Signup from "./auth/signup/Signup";
import Header from "./common/UI/Header";
import SearchPage from "./common/UI/SearchBar";
import Homepage from "./Homepage/Homepage";
import VideoMainPage from "./pages/video-pages/VideoMainPage";
import DocumentaryFullPage from "./pages/video-pages/DocumentaryFullPage";
import KidStoriesFullPage from "./pages/video-pages/KidStoriesFullPage";
import ReadingHome from "./pages/reading-pages/ReadingHome";
import ReadingViewAll from "./pages/reading-pages/view/ReadingViewAll";
import BookDetails from "./pages/reading-pages/view/BookDetails";
import AdminLogin from "./admin/pages/auth/AdminLogin";
import PrivateRoute from "./components/private/PrivateRoutes";
import NotFound from "./common/UI/NotFound";
import Dashboard from "./admin/dashboard/Dashboard";
import UploadContent from "./admin/pages/upload/UploadContents";
import AudioMain from "./AudioPage/AudioMain";
import ReadMore from "./AudioPage/ReadMore";
import AudioSeriesMain from "./AudioSeries/AudioSeriesMain";
import CommonScreen from "./AudioSeries/CommonScreen";
import EpisodeMain from "./EpisodeScreen/EpisodeMain";
import ShortsStories from "./ShortStories/ShortsStoriesMain";
import Blogs from "./Blogs/BlogsMain";
import BlogsCommonPage from "./Blogs/BlogsCommonPage";
import Playlists from "./pages/settings-pages/Playlists";
import LikedList from "./pages/settings-pages/LikedList";
import MyAccount from "./pages/settings-pages/MyAccount";
import AuthorProfile from "./pages/reading-pages/components/AuthorCommonPage";
import MyFollowing from "./pages/followers/MyFollowing";
import PublicRoute from "./components/public_route/PublicRoutes";
import AddBlogs from "./admin/pages/Add Blogs/AddBlogs";
import LogoSettings from "./admin/pages/content/components/LogoSettings";
import LinksSettings from "./admin/pages/content/components/LinksSettings";
import PagesSettings from "./admin/pages/content/components/PagesSettings";
import AddVideos from "./admin/pages/Add Videos/AddVideos";
import ForgotPassword from "./auth/forgetpassword/ForgetPassword";
import VerifyToken from "./auth/verifytoken/Verifytoken";
import ResetPassword from "./auth/resetpassword/Resetpassword";
import CategoriesSettings from "./admin/pages/content/components/CategoriesSettings";
import SeoSettings from "./admin/pages/content/components/SeoSettings";
import CategoriesShow from "./admin/pages/content/components/CategoriesShow";
import AudioSeriesCollection from "./pages/collection/AudioSeriesCollection";
import CategoiresView from "./admin/pages/content/components/CategoiresView";
import RestrictedAccess from "./components/private/RestrictedPage";
import TermsAndcondition from "./pages/terms/TermsAndcondition";
import Privacypolicy from "./pages/Privacy/Privacypolicy";
import Aboutus from "./pages/Aboutus/Aboutus";
import AudioSeriesVast from "./AudioSeries/AudioSeriesVast";
import Playlist from "./demo/Playlist";
import AddMedia from "./admin/pages/upload/UploadContents";
import EditBlogs from "./admin/pages/Add Blogs/EditBlogs";
import AddEbook from "./admin/pages/Ebook/AddEbook";
import EditEbooks from "./admin/pages/Ebook/EditEbooks";
import AddShorts from "./admin/pages/shorts/AddShorts";
import EditShorts from "./admin/pages/shorts/EditShorts";
import CategoryBlogs from "./Blogs/CategoryBlogs";
import AddAudios from "./admin/pages/Audios/AddAudios";
import AddSeries from "./admin/pages/Series/AddSeries";
import SeriesView from "./admin/pages/Series/ViewSeries";
import EditSeries from "./admin/pages/Series/EditSeries";
import BookPage from "./demo/PageFlip";
import NewDocumentaryTitle from "./pages/video-pages/NewDocumentaryTitle";
import HeroSection from "./admin/pages/content/components/HeroSection";
import BookPreview from "./components/reading/BookPreview";
import UpdateAudio from "./admin/pages/Audios/UpdateAudio";
import EpisodeCardd from "./AudioPage/EpisodeCard";
import ReadMoreNonFictional from "./AudioPage/components/ViewAll";
import SeriesEpisode from "./EpisodeScreen/SeriesEpiosde";
import { AudioPlayerProvider } from "./components/audio/AudioPlayerContext";
import ReadMoreNonFictionalComponent from "./ShortStories/ReadMoreNonFictionalComponent";
import ReadMoreSeries from "./AudioSeries/ReadMoreSeries";
import Addadvertisements from "./admin/pages/Banner-Ads/Addadvertisements";
import SingleBookDetails from "./pages/reading-pages/shortStories/SingleBooksDetails";
import SingleBookPreview from "./components/reading/SingleEbookPreview";
import ContactUsSetting from "./admin/pages/content/components/ContactUsSetting";
import EditVideo from "./admin/pages/Add Videos/EditVideos";
import FingerprintInitializer from "./components/fingerprint/FingerPrint";
import ProtectedContent from "./components/private/ProtectedRoutes";
import LimitOver from "./common/Limit Over/LimitOver";
import AudioPlay from "./pages/Audio/AudioPlay";
import AddMultipleAudios from "./admin/pages/multiple-content/AddMultipleContents";
import AddMultipleEbooks from "./admin/pages/multiple-content/AddMultipleEbooks";
import HindiReadingHome from "./pages/reading-pages/HindiReadingHome";
import AudiosByLanguage from "./pages/Audio/Component/AudiosByLanguage";
import AudiosByCategory from "./pages/Audio/Component/AudiosByCategory";
import ShortStoriesNew from "./ShortStories/ShortStoriesNew";
import GarhwaliReadingHome from "./pages/reading-pages/GarhwaliReadingHome";
import MobileNavigation from "./components/mobileNavigation/Mobilenavigation";
import EbookReader from "./components/reading/BooksReader";
import HybridScrollManager from "./components/topscroll/ScrollToTop";
import ShortsPage from "./components/shorts/ShortsWrapper";
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AudioPlayerProvider>
        <Router>
        <HybridScrollManager/>
          <FingerprintInitializer />
          <Header />
          <MobileNavigation/>
          <ToastContainer />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route
              path="/signup"
              element={
                <PublicRoute>
                  <Signup />
                </PublicRoute>
              }
            />
            <Route
              path="/signin"
              element={
                <PublicRoute>
                  <Signin />
                </PublicRoute>
              }
            />
            <Route
              path="/forget-password"
              element={
                <PublicRoute>
                  <ForgotPassword />
                </PublicRoute>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/audiobook" element={<AudioMain />} />
            <Route path="/ReadMore" element={<ReadMore />} />
            <Route path="/audioseries" element={<AudioSeriesMain />} />
            <Route path="/CommonScreen" element={<CommonScreen />} />
            <Route path="/EpisodeMain" element={<EpisodeMain />} />
            <Route
              path="/audio-play/:slug"
              element={
                <ProtectedContent>
                  <AudioPlay />
                </ProtectedContent>
              }
            />

            <Route path="/audio/:slug" element={<EpisodeMain />} />
            <Route path="/audioseries/:slug" element={<SeriesEpisode />} />
            <Route path="/audio-books/:slug" element={<SeriesEpisode />} />

            <Route path="/shortstories/:language" element={<ShortsStories />} />
            <Route path="/shortstory/:language" element={<ShortStoriesNew />} />

            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:id" element={<BlogsCommonPage />} />
            <Route path="/author/:id" element={<AuthorProfile />} />
            <Route
              path="/verify-reset-token/:token"
              element={<VerifyToken />}
            />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/collection/:id" element={<AudioSeriesCollection />} />
            <Route path="/terms" element={<TermsAndcondition />} />
            <Route path="/privacy-policy" element={<Privacypolicy />} />
            <Route path="/about" element={<Aboutus />} />
            <Route path="/audio-series/:id" element={<AudioSeriesVast />} />
            <Route path="/demo" element={<BookPage />} />
            <Route path="/demo/:id" element={<Playlist />} />
            <Route path="/blogs-category/:name" element={<CategoryBlogs />} />
            <Route
              path="/video/:id"
              element={
                <ProtectedContent>
                  <NewDocumentaryTitle />
                </ProtectedContent>
              }
            />
            <Route path="/episode/:id" element={<EpisodeCardd />} />
            <Route
              path="/short-stories/categories/:categoryId"
              element={<ReadMoreNonFictionalComponent />}
            />
            <Route path="/view-all/:name" element={<ReadMoreNonFictional />} />
            <Route path="/audio-series/view-all" element={<ReadMoreSeries />} />
            <Route path="/admin/add-banner" element={<Addadvertisements />} />
            <Route
              path="/book-detail/:id"
              element={
                <ProtectedContent>
                  <SingleBookDetails />
                </ProtectedContent>
              }
            />
            <Route path="/shorts/:slug" element={<ShortsPage />} />
            <Route
              path="/limit-over"
              element={
                <LimitOver message="You've reached the guest viewing limit for contents. Sign in to continue watching." />
              }
            />

            {/* Protected Routes */}
            <Route
              path="/restricted-page"
              element={
                <PrivateRoute>
                  <RestrictedAccess />
                </PrivateRoute>
              }
            />
            <Route
              path="/playlists"
              element={
                <PrivateRoute>
                  <Playlists />
                </PrivateRoute>
              }
            />
            <Route
              path="/following"
              element={
                <PrivateRoute>
                  <MyFollowing />
                </PrivateRoute>
              }
            />

            <Route
              path="/likes"
              element={
                <PrivateRoute>
                  <LikedList />
                </PrivateRoute>
              }
            />
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <MyAccount />
                </PrivateRoute>
              }
            />
            <Route path="/video" element={<VideoMainPage />} />
            <Route
              path="/video/category/:category"
              element={
                  <DocumentaryFullPage />
              }
            />
            <Route
              path="/KidStoriesFullPage"
              element={
                  <KidStoriesFullPage />
              }
            />

            <Route path="/reading" element={<ReadingHome />} />
            <Route path="/hindi-reading" element={<HindiReadingHome />} />
            <Route path="/garhwali-reading" element={<GarhwaliReadingHome />} />

            <Route
              path="/collection/language/:language"
              element={<AudiosByLanguage />}
            />
            <Route
              path="/collection/category/:category"
              element={<AudiosByCategory />}
            />

            <Route path="/books/:param" element={<ReadingViewAll />} />
            <Route
              path="/book-details/:id"
              element={
                <ProtectedContent>
                  <BookDetails />
                </ProtectedContent>
              }
            />

            <Route
              path="/book/:id/episode/:slug"
              element={
                <ProtectedContent>
                  <BookPreview />
                </ProtectedContent>
              }
            />
            <Route
              path="/book/:slug"
              element={
                <ProtectedContent>
                  <EbookReader />
                </ProtectedContent>
              }
            />

            {/* Admin Routes */}
            <Route
              path="/admin/*"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <AdminLogin />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/upload"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <UploadContent />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/add-blog"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <AddBlogs />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/logo"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <LogoSettings />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/links"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <LinksSettings />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/pagessettings"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <PagesSettings />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/edit-blog/:id"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <EditBlogs />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/add-media"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <AddMedia />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/add-videos"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <AddVideos />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/all-categories"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <CategoriesSettings />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/seo-setting"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <SeoSettings />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/view-categories/:categories"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <CategoriesShow />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin/edit-video/:id"
              element={
                <PrivateRoute requiredRoles={["admin", "super_admin"]}>
                  <EditVideo />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/categories/:category"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <CategoiresView />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin/contact-us"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <ContactUsSetting />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin/hero-section"
              element={
                <PrivateRoute requiredRoles={["super_admin"]}>
                  <HeroSection />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/add-ebook"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <AddEbook />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/add-multiple-ebook"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <AddMultipleEbooks />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/edit-ebook/:id"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <EditEbooks />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin/add-shorts"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <AddShorts />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin/shorts/edit/:shortId"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <EditShorts />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin/add-audio"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <AddAudios />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/add-multiple-audio"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <AddMultipleAudios />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/add-series"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <AddSeries />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/view-series/:id"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <SeriesView />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/edit-series/:id"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <EditSeries />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/edit-audio/:id"
              element={
                <PrivateRoute requiredRoles={["super_admin", "admin"]}>
                  <UpdateAudio />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </AudioPlayerProvider>
    </QueryClientProvider>
  );
}

export default App;
